import React from "react";
import CoursesImage1 from "../Assets/Examcell/certificateIMG.png";
// import CoursesImage1 from "../Assets/Slide3/Aboutimage.png";
import pdfimg from "../Assets/Examcell/PDFIMG.png";
const CertificateApprovals = () => {
  return (
    <div>
      <h1 className="text-center font-bold text-3xl pt-7 text-[#228B22]">
        AFFILIATIONS
      </h1>
      <hr
        className="section-divider my-1 border-[#D3D3D3]  mx-auto pb-5"
        style={{ width: "14%" }}
      />
      <img
        src={CoursesImage1}
        alt="Full Width Display"
        className="w-full  object-cover mb-4 sm:w-full md:w-[95%] lg:w-full xl:w-full 2xl:w-full mb-[2%] rounded-[5px]"
      />
      {/* Grid for 4 images */}
      <div className="grid grid-cols-1  sm:grid-cols-4 gap-4 p-3 mb-[1%]">
      <a href="https://srijyothipolytechnic.com/certificates/AFFILIATION25-26.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2025-26
              </h1>
              <p className="text-center text-sm">
                Extension of Affiliation for the Academic Year 2025-26.
              </p>
            </div>
          </div>
        </a>
      <a href="https://srijyothipolytechnic.com/certificates/Affiliation24-25.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2024-25
              </h1>
              <p className="text-center text-sm">
                Extension of Affiliation for the Academic Year 2024-25.
              </p>
            </div>
          </div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/Affiliation23-24.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2023-24
              </h1>
              <p className="text-center text-sm">
                Extension of Approval for the Academic Year 2023-24.
              </p>
            </div>
          </div>
        </a>
      <a href="https://srijyothipolytechnic.com/certificates/Affiliation22-23.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2022-23
              </h1>
              <p className="text-center text-sm">
                Extension of Approval for the Academic Year 2022-23.
              </p>
            </div>
          </div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/Affiliation21-22.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2021-22
              </h1>
              <p className="text-center text-sm">
                Extension of Approval for the Academic Year 2021-22.
              </p>
            </div>
          </div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/affiliation20-21.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2020-21
              </h1>
              <p className="text-center text-sm">
                Extension of Affiliation for the Academic Year 2020-21.
              </p>
            </div>
          </div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/affiliation19-20.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2019-20
              </h1>
              <p className="text-center text-sm">
                Extension of Affiliation for the Academic Year 2019-20.
              </p>
            </div>
          </div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/affiliation18-19.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2018-19
              </h1>
              <p className="text-center text-sm">
                Extension of Affiliation for the Academic Year 2018-19.
              </p>
            </div>
          </div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/AFFILIATION17-18.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2017-18
              </h1>
              <p className="text-center text-sm">
                Extension of affiliation for the academic year 2017-18.
              </p>
            </div>
          </div>
        </a>

        <a href="https://srijyothipolytechnic.com/certificates/AFFILIATION16-17.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2016-17
              </h1>
              <p className="text-center text-sm">
                Extension of affiliation for the academic year 2016-17.
              </p>
            </div>
          </div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/AFFILIATION15-16.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2015-16
              </h1>
              <p className="text-center text-sm">
                Extension of affiliation for the academic year 2015-16.
              </p>
            </div>
          </div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/AFFILIATION14-15.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">
                Affiliation Report 2014-15
              </h1>
              <p className="text-center text-sm">
                Extension of affiliation for the academic year 2014-15.
              </p>
            </div>
          </div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/AFFILIATION13-14.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg  p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold mb-1">
                Affiliation report 2013-14
              </h1>
              <p className="text-center text-sm ">
                Affiliation for New Institute/ Change of site from Academic year
                2013-2014.
              </p>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

export default CertificateApprovals;
